"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailProductsModule = void 0;
const inversify_1 = require("inversify");
const productUnserializeFactory_1 = require("../../helpers/productUnserializeFactory");
let RetailProductsModule = class RetailProductsModule {
    constructor() { }
    /**
     * Retrieve product list for a given retail location
     * This will be synced as products in the inventory are updated
     */
    retrieveSyncedProductListForRetailLocation(retailLocationId, orderType) {
        return {
            endpoint: "products",
            action: "retrieveSyncedProductListForRetailLocation",
            parameters: {
                retailLocationId,
                orderType
            },
            unseralizeData: (data) => data.products.map((product) => (0, productUnserializeFactory_1.productUnserializeFactory)(product))
        };
    }
};
RetailProductsModule = __decorate([
    (0, inversify_1.injectable)()
], RetailProductsModule);
exports.RetailProductsModule = RetailProductsModule;
//# sourceMappingURL=RetailProductsModule.js.map